import {
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputAdornment,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Chip,
  ListItem,
  Tooltip,
} from "@mui/material";
import Icon from "components/icon";
import CustomTextField from "../../components/mui/text-field";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UserLayout from "components/layouts/UserLayout";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Reports = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const reportCategories = [
    {
      title: "Customer Reports",
      reports: [
        { name: "Customer Jobs Report", comingSoon: true },
        { name: "Lead Conversion Report", comingSoon: true },
      ],
    },
    {
      title: "Employee Reports",
      reports: [
        { name: "Employee Productivity Report", comingSoon: true },
        { name: "Sales by Employee", comingSoon: true },
        { name: "Login Activity Report", path: "/reports/loginactivity" },
        { name: "Time Clock Report", path: "/reports/timeclock" },
        { name: "Payroll Report", path: "/reports/payroll" },
        { name: "Commission", comingSoon: true },
      ],
    },
    {
      title: "Work Order Reports",
      reports: [
        { name: "Work Order - All Jobs Report", comingSoon: true },
        { name: "Request Conversion Report", comingSoon: true },
      ],
    },
    {
      title: "Finance Reports",
      reports: [
        { name: "Invoice Report", comingSoon: true },
        { name: "Discount Report - Invoice Level", comingSoon: true },
        { name: "Discount Report - By Employee", comingSoon: true },
        { name: "Payment Report", comingSoon: true },
        { name: "Sales Tax Report", path: "/reports/salestax" },
      ],
    },
    { 
      title: "Service and Bundle Reports",
      reports: [
        { name: "Service and Bundle Reports", path: "/reports/serviceandbundles" }
      ],
    },
    {
      title: "Inventory Reports",
      reports: [
        { name: "View Material and Assets", comingSoon: true },
        { name: "Inventory Cost and Profit Report", comingSoon: true },
        { name: "Service and Bundle Reports", comingSoon: true },
      ],
    },
    {
      title: "Other Reports",
      reports: [
        { name: "Tags", path: "/reports/tags" }, 
        { name: "Customer Referral", comingSoon: true }, 
        { name: "Marketing Source", comingSoon: true }
      ],
    },
  ];

  // Filter categories based on search
  const filteredCategories = reportCategories
    .map((category) => {
      const filteredReports = category.reports.filter((report) => {
        return report.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
      return { ...category, reports: filteredReports };
    })
    .filter((category) => category.reports.length > 0);

  const handleNavigation = (to) => {
    navigate(to);
  };

  const handlePageBack = () => {
    handleNavigation('/reports');    
  };

  const handleReportClick = (report) => {
    if (report.path && !report.comingSoon) {
      navigate(report.path);
    }
  };

  return (
    <UserLayout 
      contentHeightFixed={false}
      NavURL={handlePageBack}
      activeLink="All Reports"
    >
      <Card
        sx={{
          p: 3,
          boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
          height: "100%",
          width: "100%",
          overflowX: "auto",
          mx: "auto",
          mt: 4,
        }}
      >
        <CardContent sx={{ height: "100%", minWidth: { xs: "320px", sm: "100%" } }}>
          {/* Header */}
          <Typography variant="h3" gutterBottom>
            All Reports
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={2}>
            View and access reports from every module in one place. Expand categories to see more reports, and tap a report to open its detailed view.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Search Bar */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", mb: 2 }}>
            <CustomTextField
              placeholder="Search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon icon="tabler:search" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {/* Accordions */}
          {filteredCategories.map((category, i) => (
            <Accordion 
              key={i} 
              disableGutters 
              sx={{ 
                mb: 4, 
                borderRadius: 2, 
                overflow: "hidden",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h5">{category.title}</Typography>
              </AccordionSummary>
              
              <AccordionDetails>
                <List disablePadding>
                  {category.reports.map((report, j) => (
                    <ListItem
                      key={j}
                      sx={{ 
                        pl: 2,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        '&:hover': {
                          backgroundColor: report.comingSoon ? 'transparent' : 'action.hover'
                        }
                      }}
                      disablePadding
                    >
                      <ListItemButton
                        sx={{ 
                          flex: 1,
                          cursor: report.comingSoon ? 'default' : 'pointer',
                          '&:hover': {
                            backgroundColor: report.comingSoon ? 'transparent' : 'inherit'
                          }
                        }}
                        onClick={() => handleReportClick(report)}
                      >
                        <ListItemText 
                          primary={report.name}
                          sx={{
                            opacity: report.comingSoon ? 0.8 : 1,
                          }}
                        />
                      </ListItemButton>
                      
                      {report.comingSoon && (
                        
                          <Chip 
                            label="Coming Soon" 
                            size="small"  
                            variant="filled"
                            sx={{ 
                              ml: 2,
                              backgroundColor: 'grey.300', 
                              color: 'grey.600',
                              '& .MuiChip-icon': {
                                color: 'grey.600', 
                              }
                            }}
                            icon={<Icon icon="tabler:info-circle" />} 
                          />
                        
                      )}
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
        </CardContent>
      </Card>
    </UserLayout>
  );
};

export default Reports;